// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"SrAdminUploadInsurancePolicyModal--checkboxes--18DiV","highlightYellowFadeIn":"SrAdminUploadInsurancePolicyModal--highlightYellowFadeIn--1uDND"};